import type { SideNavSectionRoutes } from "./useSideNavSections";

/** Org nav sections, in order, with the routes that reopen each one. */
export const ORG_SIDE_NAV_SECTIONS = [
    { label: "Clients", paths: ["/"] },
    { label: "Templates", paths: ["/templates/*"], isCollapsedByDefault: true },
    {
        label: "Automation",
        paths: ["/automation/*"],
        isCollapsedByDefault: true,
    },
    {
        label: "Firm",
        paths: [
            "/organization-billing",
            "/team",
            "/organization-integrations",
            "/organization-api",
            "/organization-member-access-log",
        ],
        isCollapsedByDefault: true,
    },
] satisfies readonly SideNavSectionRoutes[];
